import type { ReactNode } from "react"
import { Button } from "@/components/ui/Button"
import { cn } from "@/lib/utils"
import type { Market } from "@/lib/useMarket"
import { openProductQuickView } from "./store"

interface Props {
  externalId: string
  /** The market to open on; leave it out on a market page to use that market. */
  market?: Market | null
  title?: string
  className?: string
  children: ReactNode
}

// A product name that opens the product quick view. The click stays here, so
// a clickable row around it does not also react.
export default function ProductLink({ externalId, market = null, title, className, children }: Props) {
  return (
    <Button
      variant="link"
      className={cn("h-auto min-w-0 max-w-full justify-start whitespace-normal p-0 text-left text-sm font-normal", className)}
      title={title}
      onClick={(e) => {
        e.stopPropagation()
        openProductQuickView(externalId, market)
      }}
    >
      {children}
    </Button>
  )
}
